var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "FormGroup",
    {
      attrs: {
        state: _vm.error === null,
        "invalid-feedback": _vm.showError ? _vm.error : undefined,
        "add-invalid-class": false,
        "feedback-beneath": ""
      }
    },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "4" } },
            [
              _c(
                "FormGroup",
                { attrs: { state: _vm.countryCodeValid, "no-margin": "" } },
                [
                  _c("b-form-select", {
                    attrs: { options: _vm.countryCodes },
                    on: { input: _vm.emitChangeEvent },
                    model: {
                      value: _vm.countryCode,
                      callback: function($$v) {
                        _vm.countryCode = $$v
                      },
                      expression: "countryCode"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { md: "8" } },
            [
              _c(
                "FormGroup",
                {
                  staticClass: "mt-2 mt-md-0",
                  attrs: { state: _vm.numberValid, "no-margin": "" }
                },
                [
                  _c("b-input", {
                    attrs: { placeholder: "Mobil-Nummer" },
                    on: { input: _vm.emitChangeEvent },
                    model: {
                      value: _vm.number,
                      callback: function($$v) {
                        _vm.number = $$v
                      },
                      expression: "number"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }